import { createContext, useContext, useEffect, useState } from "react";
// Include short landscape phone windows while keeping portrait tablets unchanged.
export const PHONE_QUERY = "(max-width: 767px), (max-width: 1023px) and (max-height: 500px)";
const PhoneLayout = createContext(false);
export function PhoneLayoutProvider({ children }) {
  const [phone, setPhone] = useState(() => window.matchMedia(PHONE_QUERY).matches);
  useEffect(() => {
    const query = window.matchMedia(PHONE_QUERY);
    const update = () => setPhone(query.matches);
    update();
    if (query.addEventListener) query.addEventListener("change", update);
    else query.addListener(update);
    return () => {
      if (query.removeEventListener) query.removeEventListener("change", update);
      else query.removeListener(update);
    };
  }, []);
  return <PhoneLayout.Provider value={phone}>{children}</PhoneLayout.Provider>;
}
export const usePhoneLayout = () => useContext(PhoneLayout);
